import apiHero from '@/api/hero'

const state = {
	data: {},
	video: null
}

const getters = {
	data(state) {
		return state.data
	},
	video(state) {
		return state.video
	}
}

const mutations = {
	setData(state, data) {
		state.data = data
	},
	setVideo(state, video) {
		state.video = video
	}
}

const actions = {
	fetchData({ commit }) {
		apiHero.getData(data => commit('setData', data))
	},
	fetchVideo({ commit }, video) {
		commit('setVideo', video)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
